import { render, staticRenderFns } from "./ImportEditPimView.vue?vue&type=template&id=b636a62e"
import script from "./ImportEditPimView.vue?vue&type=script&lang=js"
export * from "./ImportEditPimView.vue?vue&type=script&lang=js"
import style0 from "./ImportEditPimView.vue?vue&type=style&index=0&id=b636a62e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports